import { DataItem } from '../../../../../../@types/DataItem';
import { ChannelsConfigSchema } from '../../../../../../reducers/reducerIPA/channels';
import { MechanismType, RulePriceType } from './utils';

const mechanismType = (rulePriceType: RulePriceType = 'REGULAR') => {
  const data: { label: string; value: MechanismType }[] = [
    /*
            Essa opção de mechanismo será implementada em um PR futuro
            Durante o desenvolvimendo da feature, foi encontrado um impedimento de backend
            Como a função feature já havia sido implementada no front-end
            E existem algumas validações na criação e edição de regra, baseado nessa opção
            Optei por deixar somente essa opção que influencia na visualização do usuário
        */

    // { label: 'Desconto preço regular', value: 'REGULAR_PRICE_DISCOUNT' },
    { label: 'Competitividade', value: 'COMPETITIVIDADE' },
    { label: 'Margem', value: 'MARGEM' },
    { label: 'Desconto PMC', value: 'PMC' },
    { label: 'Margem objetiva', value: 'MARGEM_OBJETIVA' },
  ];
  return rulePriceType === 'OFFER' ? data : data.filter(({ value }) => value !== 'REGULAR_PRICE_DISCOUNT');
};

export const mechanismTypeMap = new Map([
  ['COMPETITIVIDADE', 'Competitividade'],
  ['MARGEM', 'Margem'],
  ['MARGEM_OBJETIVA', 'Margem objetiva'],
  ['PMC', 'Desconto PMC'],
  ['REGULAR_PRICE_DISCOUNT', 'Desconto preço oferta'],
  ['MANUAL', 'Manual'],
]);

export const aditionalMechanismTypeValue = ['MARGEM', 'MARGEM_OBJETIVA', 'PMC'] as const;

export type AditionalMechanismTypeValue = (typeof aditionalMechanismTypeValue)[number];

export const aditionalMechanismType: {
  label: string;
  value: AditionalMechanismTypeValue;
}[] = [
  { label: 'Margem', value: 'MARGEM' },
  { label: 'Margem objetiva', value: 'MARGEM_OBJETIVA' },
  { label: 'Desconto PMC', value: 'PMC' },
];

const recurrenceTypes = [
  { label: 'Diária', value: 'DAILY' },
  { label: 'Semanal', value: 'WEEKLY' },
  { label: 'Mensal', value: 'MONTHLY' },
];

const datePickerLocale = {
  sunday: 'Dom',
  monday: 'Seg',
  tuesday: 'Ter',
  wednesday: 'Qua',
  thursday: 'Qui',
  friday: 'Sex',
  saturday: 'Sáb',
  ok: 'OK',
  today: 'Hoje',
};

const monthlyRecurrenceType = [
  {
    label: 'Primeira',
    value: 'FIRST',
  },
  {
    label: 'Segunda',
    value: 'SECOND',
  },
  {
    label: 'Terceira',
    value: 'THIRD',
  },
  {
    label: 'Quarta',
    value: 'FOURTH',
  },
  {
    label: 'Última',
    value: 'LAST',
  },
];

const monthlyRecurrenceDayOfWeek = [
  {
    label: 'Segunda-feira',
    value: 'MONDAY',
  },
  {
    label: 'Terça-feira',
    value: 'TUESDAY',
  },
  {
    label: 'Quarta-feira',
    value: 'WEDNESDAY',
  },
  {
    label: 'Quinta-feira',
    value: 'THURSDAY',
  },
  {
    label: 'Sexta-feira',
    value: 'FRIDAY',
  },
  {
    label: 'Sábado',
    value: 'SATURDAY',
  },
  {
    label: 'Domingo',
    value: 'SUNDAY',
  },
];

const priceCompetitorIndicator = [
  { label: 'Média do preço concorrente', value: 'AVERAGE' },
  { label: 'Preço mais alto', value: 'HIGHER' },
  { label: 'Preço mais baixo', value: 'LOWER' },
];

const abcClass = async () => {
  const data = [
    { label: 'A', value: 'A' },
    { label: 'B', value: 'B' },
    { label: 'C', value: 'C' },
    { label: 'D', value: 'D' },
  ];
  return new Promise<typeof data>(resolve => {
    resolve(data);
  });
};

export type StoreType = 'individual-store' | 'all-stores' | 'clusters';

const storeType: DataItem[] = [
  { value: 'individual-store', label: 'Loja' },
  { value: 'clusters', label: 'Cluster' },
  { value: 'all-stores', label: 'Todas as lojas' },
];

export const segmentsType: DataItem[] = [
  { value: 'infoPriceSensibility', label: 'Sensibilidade InfoPrice' },
  { value: 'infoPriceAbcClass', label: 'Curva ABC Local' },
  { value: 'infoPriceGlobalAbcClass', label: 'Curva ABC Global' },
  { value: 'sensibilityType', label: 'Exclusiva' },
  { value: 'abcClass', label: 'Curva' },
];

const rulePriceTypeDataItem: DataItem[] = [
  { label: 'Regular', value: 'REGULAR' },
  { label: 'Oferta', value: 'OFFER' },
];

const rulePriceType: (channels?: ChannelsConfigSchema) => DataItem[] = channels => {
  if (!channels?.offer.enabled || !channels?.offer.allowCreateRule) {
    return rulePriceTypeDataItem.filter(({ value }) => value !== 'OFFER');
  }

  return rulePriceTypeDataItem;
};

const data = {
  mechanismType,
  aditionalMechanismType,
  recurrenceTypes,
  datePickerLocale,
  monthlyRecurrenceType,
  monthlyRecurrenceDayOfWeek,
  priceCompetitorIndicator,
  abcClass,
  storeType,
  segmentsType,
  rulePriceTypeDataItem,
  rulePriceType,
} as const;

export default data;
